import { useMutation } from '@tanstack/react-query';
import { matchingService } from '../services/matching.service';
import type { MatchingSearchResponse } from '../types/matching.types';

/**
 * Hook pour lancer une recherche de matching IA
 * Utilise useMutation car c'est un POST avec side-effects (coûts IA)
 */
export function useMatchingSearch() {
  return useMutation<
    MatchingSearchResponse,
    Error,
    { rawInput: string; locationMode?: string; budgetTolerance?: string; candidateIds?: number[] }
  >({
    mutationFn: ({ rawInput, locationMode, budgetTolerance, candidateIds }) =>
      matchingService.search(rawInput, locationMode, budgetTolerance, candidateIds),
  });
}
